// @flow

import WidgetSettings from './WidgetSettings';
import { widgetSettingsShape } from './PropTypes';
import withWidgetSettings from './withWidgetSettings';
import withWidgetSettingsProvider from './withWidgetSettingsProvider';
import WidgetSettingsContext from './WidgetSettingsContext';

export default WidgetSettings;
export {
  widgetSettingsShape,
  withWidgetSettings,
  withWidgetSettingsProvider,
  WidgetSettingsContext,
};
export type { WidgetSettings } from './types';
